__turbopack_context__.v({
  "className": "roboto_660ee966-module__rz71ha__className",
  "variable": "roboto_660ee966-module__rz71ha__variable",
});
